import TrainMargin from './TrainMargin';

export default TrainMargin;
